import React from 'react';
import { FaChevronLeft, FaChevronRight, FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';
import '../assets/css/Pagination.css';

const PaginationComponent = ({ 
  currentPage, 
  lastPage, 
  onPageChange, 
  disabled,
  maxVisible = 5 // عدد الأرقام الظاهرة في المنتصف
}) => {
  // حساب النطاق المعروض من الصفحات
  const getVisiblePages = () => {
    if (lastPage <= maxVisible) {
      return Array.from({ length: lastPage }, (_, i) => i + 1);
    }

    const pages = [];
    const half = Math.floor(maxVisible / 2);
    let start = Math.max(1, currentPage - half);
    let end = Math.min(lastPage, start + maxVisible - 1);
    
    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }
    
    // إظهار dots إذا كان هناك صفحات قبل النطاق
    const showStartDots = start > 1;
    const showEndDots = end < lastPage;
    
    // الصفحة الأولى
    if (showStartDots) {
      pages.push(1);
    }
    
    // Dots البداية
    if (showStartDots && start > 2) {
      pages.push('...');
    }
    
    // الصفحات المرئية
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    
    // Dots النهاية
    if (showEndDots && end < lastPage - 1) {
      pages.push('...');
    }
    
    // الصفحة الأخيرة
    if (showEndDots) {
      pages.push(lastPage);
    }
    
    return pages;
  };

  const visiblePages = getVisiblePages();

  return (
    <nav className="pagination-wrapper" aria-label="Page navigation">
      <ul className="pagination-modern">
        {/* First */}
        <li className={`page-item ${disabled || currentPage === 1 ? 'disabled' : ''}`}>
          <button 
            className="page-link page-nav"
            onClick={() => onPageChange(1)}
            disabled={disabled || currentPage === 1}
            aria-label="First page"
          >
            <FaAngleDoubleLeft />
          </button>
        </li>

        {/* Previous */}
        <li className={`page-item ${disabled || currentPage === 1 ? 'disabled' : ''}`}>
          <button 
            className="page-link page-nav"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={disabled || currentPage === 1}
            aria-label="Previous page"
          >
            <FaChevronLeft />
          </button>
        </li>

        {/* Pages */}
        {visiblePages.map((page, index) => {
          if (page === '...') {
            return (
              <li key={`dots-${index}`} className="page-item page-dots">
                <span className="page-link">…</span>
              </li>
            );
          }
          
          return (
            <li 
              key={page} 
              className={`page-item ${page === currentPage ? 'active' : ''}`}
            >
              <button
                className="page-link"
                onClick={() => onPageChange(page)}
                disabled={disabled}
                aria-current={page === currentPage ? 'page' : undefined}
              >
                {page}
              </button>
            </li>
          );
        })}

        {/* Next */}
        <li className={`page-item ${disabled || currentPage === lastPage ? 'disabled' : ''}`}>
          <button 
            className="page-link page-nav"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={disabled || currentPage === lastPage}
            aria-label="Next page"
          >
            <FaChevronRight />
          </button>
        </li>

        {/* Last */}
        <li className={`page-item ${disabled || currentPage === lastPage ? 'disabled' : ''}`}>
          <button 
            className="page-link page-nav"
            onClick={() => onPageChange(lastPage)}
            disabled={disabled || currentPage === lastPage}
            aria-label="Last page"
          >
            <FaAngleDoubleRight />
          </button>
        </li>
      </ul>

      {/* معلومات الصفحة (للشاشات الصغيرة) */}
      <div className="pagination-info">
        <span className="page-info-text">
          {currentPage} / {lastPage}
        </span>
      </div>
    </nav>
  );
};

export default PaginationComponent;